export class EntitlementService {
    constructor(adaptableApi) {
        this.adaptableApi = adaptableApi;
        this.adaptableApi = adaptableApi;
    }
    setModulesEntitlements() {
        this.adaptableApi.internalApi
            .getModuleService()
            .getModuleCollection()
            .forEach((module) => {
            module.setModuleEntitlement();
        });
    }
    isModuleHiddenEntitlement(adaptableModule) {
        return this.getEntitlementAccessLevelForModule(adaptableModule) == 'Hidden';
    }
    isModuleFullEntitlement(adaptableModule) {
        return this.getEntitlementAccessLevelForModule(adaptableModule) == 'Full';
    }
    isModuleReadOnlyEntitlement(adaptableModule) {
        return this.getEntitlementAccessLevelForModule(adaptableModule) == 'ReadOnly';
    }
    getEntitlementAccessLevelForModule(adaptableModule) {
        let adaptableOptions = this.adaptableApi.optionsApi.getAdaptableOptions();
        let entitlementOptions = adaptableOptions.entitlementOptions;
        if (entitlementOptions) {
            const defaultAccessLevelContext = {
                userName: adaptableOptions.userName,
                adaptableId: adaptableOptions.adaptableId,
                adaptableApi: this.adaptableApi,
            };
            const defaultAccessLevel = typeof entitlementOptions.defaultAccessLevel === 'function'
                ? entitlementOptions.defaultAccessLevel(defaultAccessLevelContext)
                : entitlementOptions.defaultAccessLevel;
            const moduleEntitlements = entitlementOptions.moduleEntitlements;
            if (moduleEntitlements) {
                if (typeof moduleEntitlements === 'function') {
                    const entitlementContext = {
                        adaptableModule,
                        userName: adaptableOptions.userName,
                        adaptableId: adaptableOptions.adaptableId,
                        defaultAccessLevel,
                        adaptableApi: this.adaptableApi,
                    };
                    const dynamicModuleEntitlement = moduleEntitlements(entitlementContext);
                    return dynamicModuleEntitlement !== null && dynamicModuleEntitlement !== void 0 ? dynamicModuleEntitlement : defaultAccessLevel;
                }
                else {
                    const entitlement = moduleEntitlements.find((f) => f.adaptableModule === adaptableModule);
                    if (entitlement) {
                        return entitlement.accessLevel;
                    }
                }
            }
            // if still here then return their default Access Level
            return defaultAccessLevel;
        }
        return 'Full';
    }
    destroy() {
        // TO DO
    }
}
